import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { Portal } from 'react-portal';
import throttle from 'lodash/throttle';

import AgeGate from '../AgeGate';


export function DishAgeGate(props) {
    const {
        triggerAgeGate,
        containerRef,
    } = props;

    const [ageGateState, setAgeGateState] = useState('disabled');

    useEffect(() => {
        if (!triggerAgeGate || !containerRef.current) {
            return () => {};
        }

        if (ageGateState === 'disabled') {
            setAgeGateState('hidden');
        }

        const listenToScroll = throttle(() => {
            const position = containerRef.current.getBoundingClientRect().y;
            if (position <= window.innerHeight && ageGateState === 'hidden') {
                setAgeGateState('visible');
            }
        }, 300);

        document.addEventListener('scroll', listenToScroll);

        return () => {
            document.removeEventListener('scroll', listenToScroll);
        };
    }, [triggerAgeGate, ageGateState, containerRef]);

    const handleConfirmAgeGate = useCallback(() => {
        setAgeGateState('closed');
    }, []);

    const handleRejectAgeGate = useCallback(() => {
        window.location = '/menu/';
    }, []);


    return (
        <Portal>
            {ageGateState === 'visible' && (
                <AgeGate
                    onClickResolve={handleConfirmAgeGate}
                    onClickReject={handleRejectAgeGate}
                />
            )}
        </Portal>
    );
}

DishAgeGate.propTypes = {
    triggerAgeGate: PropTypes.bool.isRequired,
    containerRef: PropTypes.shape({
        current: PropTypes.shape({
            getBoundingClientRect: PropTypes.func.isRequired,
        }),
    }).isRequired,
};
